(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var bar = document.getElementById('ll-catbar');
  if (!bar) return;

  var sentinel = document.querySelector('.ll-catbar-sentinel');
  var spacer = document.getElementById('ll-catbar-spacer');
  var burger = document.querySelector('.ll-burger');
  var drawer = document.getElementById('ll-drawer');
  var stuck = false;

  function syncSticky() {
    if (!sentinel) return;
    var shouldStick = sentinel.getBoundingClientRect().top <= 0;
    if (shouldStick === stuck) return;
    stuck = shouldStick;
    bar.classList.toggle('is-stuck', shouldStick);
    if (spacer) {
      spacer.classList.toggle('is-active', shouldStick);
      spacer.style.height = shouldStick ? bar.offsetHeight + 'px' : '';
    }
  }

  syncSticky();
  window.addEventListener('scroll', syncSticky, { passive: true });
  window.addEventListener('resize', function () {
    if (stuck && spacer) spacer.style.height = bar.offsetHeight + 'px';
    syncSticky();
  });

  if (burger) {
    burger.addEventListener('click', function () {
      var expanded = burger.getAttribute('aria-expanded') === 'true';
      burger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });
  }

  if (drawer) {
    document.addEventListener('click', function (event) {
      if (event.target.closest('.menu-close-icon')) {
        if (burger) burger.setAttribute('aria-expanded', 'false');
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    class ProductModal extends ModalDialog {
        constructor() {
            super();
        }
        hide() {
            super.hide();
        }
        show(opener) {
            super.show(opener);
            this.showActiveMedia();
        }
        showActiveMedia() {
            this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
                element.classList.remove('active');
            })
            const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
            const activeMediaTemplate = activeMedia.querySelector('template');
            const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
            activeMedia.classList.add('active');
            activeMedia.scrollIntoView();
            const container = this.querySelector('[role="document"]');
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
            if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
                activeMedia.loadContent();
            }
        }
    customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
